import React, { createContext, useCallback, useState } from 'react';
import HttpAction from 'modules/utils/HttpAction';
import ContestContext from "modules/contexts/common/contestContext";
import axios from "axios";
const FilesContext = React.createContext({
    state: {
        filesListInfo: {}
    },
    actions: {
        getFilesList: () => { },
        getFiles: () => { },
        saveFiles: () => { },
        updateFiles: () => { },
        deleteFiles: () => { },
        fileListCheck: () => { },
        downloadFile: () => { },
        downloadZipFile: () => { },
        getParticipantList: () => { },
        downloadFilesAll: () => { }
    }
});

const { Provider } = FilesContext;

const FilesProvider = ({ children }) => {

    const [filesListInfo, setFilesListInfo] = useState({});

    const fileListCheck = (toggleAllFlg, checkedValue, index) => {

        const temp = { ...filesListInfo };
        const tempList = [...temp.listData];

        if (toggleAllFlg) {
            tempList.forEach(e => {
                e.checkFlg = checkedValue;
            })
        } else {
            tempList[index].checkFlg = checkedValue;
        }

        temp.listData = tempList;
        setFilesListInfo(temp);
    }

    const downloadFile = useCallback((fileId) => {
        HttpAction({
            url: '/file/download',
            method: 'get',
            params: {
                fileId: fileId
            }
        }).then(res => {

        })

    }, []);

    const downloadZipFile = useCallback((fileIds) => {
        HttpAction({
            url: '/file/download/zip',
            method: 'get',
            params: {
                fileIds: fileIds,
                fileName: "fileList"
            }
        }).then(res => {

        })

    }, []);

    const downloadFilesAll = useCallback((contestId) => {
        HttpAction({
            url: '/file/download/team',
            method: 'get',
            params: {
                contestId: contestId
            }
        }).then(res => {

        })

    }, []);

    const getFilesList = useCallback((requestPage = { page: 1, records: 10 }) => {
        HttpAction({
            url: '/file',
            method: 'get',
            params: { ...requestPage }

        }).then(res => {

        })

    }, []);

    const getParticipantList = useCallback((contestId) => {
        axios({
            url: '/file/download/team',
            method: 'get',
            params: {
                contestId: contestId
            },
            headers: {
                Authorization: `Bearer ${sessionStorage.getItem("jwt")}`
            }
        }).then(function (response) {
            const url = window.URL.createObjectURL(new Blob(["\ufeff" + response.data], { type: response.headers['content-type'] }));
            const link = document.createElement('a');
            let filepath = response.headers['content-disposition'].split("=");
            let filename = decodeURI(filepath[1]).replaceAll("_", "").replaceAll('"', '').replaceAll('+', '_');
            link.href = url;
            link.setAttribute('download', filename);
            document.body.appendChild(link);
            link.click();
        });
    }, []);

    const getFiles = () => {

    }

    const saveFiles = (formData) => {
        HttpAction({
            method: "post",
            url: "/file",
            data: formData,
            fileused: true,
            headers: {
                'Accept': 'application/json',
            },
        })
            .then((res) => {
                // setFilesListInfo([...filesListInfo, {fileName: res.data.fileName, fileId: res.data.fileId, file: res.data.file}])
                // setFilesListInfo([
                //     ...filesListInfo,
                //     {
                //         fileName: res.data.fileName,
                //         fileId: res.data.fileId,
                //         file: res.data.file,
                //         path: res.data.filePath,
                //         size: res.data.fileSize,
                //     }
                // ])
                setFilesListInfo({
                    fileName: res.data.fileName,
                    fileId: res.data.fileId,
                    file: res.data.file,
                    path: res.data.filePath,
                    size: res.data.fileSize,
                })

            }).catch((err) => {
                console.log(err);
            });
    }

    const updateFiles = () => {

    }

    const deleteFiles = (base64) => {
        let fileList = filesListInfo;
        fileList.map((file, i) => {

            if (`${file.file}` == base64) {
                fileList.splice(i, 1);
            }
        })

        setFilesListInfo([...fileList]);
    }

    const value = {
        state: {
            filesListInfo
        },
        actions: {
            getFilesList, getFiles, saveFiles, updateFiles, deleteFiles, fileListCheck, downloadFile, downloadZipFile, getParticipantList, downloadFilesAll
        }
    }

    return <Provider value={value}>{children}</Provider>
}

export { FilesContext, FilesProvider };
